import React from 'react';
import { Box, Spinner, Text } from '@chakra-ui/react';

const Preloader = () => (
  <Box
    position="fixed"
    top="0"
    left="0"
    width="100vw"
    height="100vh"
    backgroundColor="rgba(255, 255, 255, 0.9)"
    display="flex"
    flexDirection="column"
    justifyContent="center"
    alignItems="center"
    zIndex="9999"
  >
    <Spinner size="xl" color="blue.500" mb={4} />
    <Text fontSize="lg" color="gray.700">
      Loading, please wait...
    </Text>
  </Box>
);

export default Preloader;
